// extracted by mini-css-extract-plugin
export default {"switching":"f1JEoyc4jiubEdqASI4HEA==","noneBorder":"HCZDtIjBD5in7CQDm7Pp6w=="};